import { ISession } from '../../services/apiService'
import { ICoords } from '../main/components/RefuelModal/types'

/**
 * What the mobile app puts in the link it opens this page with:
 * `?token=…&phone=…&lng=…&lat=…` (see the «mobile app link generation»
 * Postman collection).
 */
export interface IAppLink {
  /** Missing when the token or the phone is absent — nothing can be called then. */
  session?: ISession
  /** Where the driver is, when the app knew — the station within reach is picked for them. */
  coords?: ICoords
}

const readNumber = (value: string | null) => {
  // 1C formats with a dot and no grouping; anything else is not a coordinate.
  const parsed = value === null || value.trim() === '' ? NaN : Number(value)
  return Number.isFinite(parsed) ? parsed : undefined
}

export const readLink = (search: string): IAppLink => {
  const params = new URLSearchParams(search)
  const token = (params.get('token') || '').trim()
  const phone = (params.get('phone') || '').replace(/\D/g, '')
  const lat = readNumber(params.get('lat'))
  const lng = readNumber(params.get('lng'))

  return {
    session: token && phone ? { phone, token } : undefined,
    coords: lat !== undefined && lng !== undefined ? { lat, lng } : undefined,
  }
}
